import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 680, // <-- set sm breakpoint to 680px
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: "#2d5a4a",
    },
    secondary: {
      main: "#f3f4f7",
    },
    colortwo: {
      main: "#2d5a4a",
    },
    colorthree: {
      main: "#2d5a4a1a",
    },
    colorfour: {
      main: "#070A52",
    },
    colorfive: {
      main: "#2d5a4a15", //faded teal layer 1
    },
    colorsix: {
      main: "#2d5a4a0f", //faded teal layer 2
    },
    colorseven: {
      main: "#2d5a4a20", //faded teal layer 3
    },
    coloreight: {
      main: "#2d5a4a25",
    },
    fontcolor: {
      main: "#f0f2d3",
    },
    iconColor: {
      main: "#2d5a4a",
    },
    heading: {
      main: "#2d5a4a",
    },
    para: {
      main: "#2d5a4a",
    },

    menuHeading: {
      main: "#9299b8",
    },
    menuItem: {
      main: "#272b41",
    },
    black: {
      main: "#000",
    },

    background: {
      main: "#f2eee6",
    },
    whiteFont: {
      main: "#f2eee6",
    },
    selectedMenuFont: {
      main: "#2d5a4a",
    },
    selectedMenuBack: {
      main: "#2d5a4a15",
    },
  },
  typography: {
    fontFamily: "IBM Plex Sans, sans-serif",
    //fontFamily: "Inter, sans-serif",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "*::-webkit-scrollbar": {
          width: "8px",
          height: "8px",
        },
        "*::-webkit-scrollbar-track": {
          background: "#f1f1f1",
        },
        "*::-webkit-scrollbar-thumb": {
          background: "#2d5a4a",
          borderRadius: "4px",
        },
        "*::-webkit-scrollbar-thumb:hover": {
          background: "#1f3d33",
        },
      },
    },
  },
});

export default theme;
